import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { Auth } from '../auth/auth';

declare global {
  interface Window {
    activeApiRequests?: number;
  }
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const router = inject(Router);

  window.activeApiRequests = (window.activeApiRequests ?? 0) + 1;

  const userObj = localStorage.getItem(auth.AUTH_USER);
  const user = userObj ? JSON.parse(userObj) : null;
  let headers = req.headers.set('version', '1');

  if (user?.accessToken) {
    headers = headers.set('Authorization', `Bearer ${user.accessToken}`).set('x-page-url', router.url);

    if (user.group_id) {
      headers = headers.set('x-group-id', user.group_id.toString());
    }
  }

  return next(req.clone({ headers })).pipe(
    finalize(() => {
      window.activeApiRequests = Math.max(0, (window.activeApiRequests ?? 1) - 1);
      window.dispatchEvent(new CustomEvent('api_activity'));
    }),
  );
};
